class Store {
  constructor() {
    this.vars = window.statelyVars || {};
    this.init();
  }

  init() {
    this.setOrderTag();
  }

  setOrderTag() {
    const orderTag = sessionStorage.getItem('order_tag');
    if (orderTag) {
      document.querySelector('.product-form form')?.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_order_tag]" value="${orderTag}" />`);
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  window.store = new Store();
});